export default __webpack_public_path__ + "static/media/aepfel.51330e3e.png";